// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/proforme-acconto?societaId={id}&stato={s}&includeAnnullate={bool}&origine={o}&commessaId={cid}&ordineId={oid}&acquirenteId={aid}&dataDa={d}&dataA={d}&q={q}',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","numero":"string","origine":"string","stato":"string","commessaId":"number","commessa":{"numero":"string"},"ordineId":"number|null","acquirenteId":"number|null","imponibile":"string","iva":"string","totale":"string","clienteRagioneSociale":"string","dataEmissione":"string","dataPagamento":"string|null","totaleIncassato":"number","residuo":"number"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/commesse?societaId={id}',
    requestBody: null,
    response: '{"commesse":[{"id":"number","numero":"string","descrizione":"string","clienteRagioneSociale":"string"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/commesse?societaId={id}',
    requestBody: null,
    response: '{"commesse":[{"id":"number","numero":"string","descrizione":"string","clienteRagioneSociale":"string"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/codici-iva?societaId={id}&attivo=true',
    requestBody: null,
    response: '{"codici":[{"id":"number","codice":"string","descrizione":"string","aliquota":"string","attivo":"boolean"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/pagamenti?societaId={id}',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","nome":"string"}],"condizioni":[{"id":"number","nome":"string"}]}'
  },
  {
    method: 'POST',
    endpoint: '/api/proforme-acconto',
    requestBody: '{"societaId":"number","commessaId":"number","imponibile":"number","codiceIvaId":"number","descrizione":"string|null","note":"string|null","condizionePagamentoId":"number|null"}',
    response: '{"success":true,"data":{"id":"number"}}'
  },
  {
    method: 'POST',
    endpoint: '/api/proforme-acconto/:id/annulla',
    requestBody: '{"motivoAnnullamento":"string"}',
    response: '{"success":true}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
